import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import androidImg from "../../images/app-cost-calculator/android.png";
import androidHoverImg from "../../images/app-cost-calculator/android-hover.png";
import isoImg from "../../images/app-cost-calculator/iso.png";
import isoHoverImg from "../../images/app-cost-calculator/iso-hover.png";
import crossPlatformImg from "../../images/app-cost-calculator/cross-plateform.png";
import crossPlatformHoverImg from "../../images/app-cost-calculator/cross-plateform-hover.png";

// Section 2

import ecommerceImg from "../../images/app-cost-calculator/e-commerce.png"; // Adjust the path as needed
import ecommerceHoverImg from "../../images/app-cost-calculator/e-commerce-hover.png";
import socialImg from "../../images/app-cost-calculator/social.png";
import socialHoverImg from "../../images/app-cost-calculator/social-hover.png";
import bookingImg from "../../images/app-cost-calculator/booking.png";
import bookingHoverImg from "../../images/app-cost-calculator/booking-hover.png";
import cabAppImg from "../../images/app-cost-calculator/cab-app.png";
import cabAppHoverImg from "../../images/app-cost-calculator/cab-app-hover.png";
import customAppImg from "../../images/app-cost-calculator/custom-app.png";
import customAppHoverImg from "../../images/app-cost-calculator/custom-app-hover.png";

// Form Image
import FormImage from "../../images/app-cost-calculator/email-img.png";

function MultiStep() {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Disable manual scrolling
    const preventScroll = (e) => e.preventDefault();
    window.addEventListener("wheel", preventScroll, { passive: false });

    return () => {
      window.removeEventListener("wheel", preventScroll, { passive: false });
    };
  }, []);


  const gatherDataFromSections = () => {
    const sections = document.querySelectorAll(".section-bg");
    const data = {};
  
    sections.forEach((section) => {
      const inputs = section.querySelectorAll(
        'input[type="text"], input[type="email"], input[type="radio"]:checked, input[type="checkbox"]:checked'
      );
  
      inputs.forEach((input) => {
        if (input.type === "checkbox") {
          if (!data[input.name]) {
            data[input.name] = [];
          }
          data[input.name].push(input.value); // Collecting all checked values
        } else {
          data[input.name] = input.value; // For text, email, radio inputs
        }
      });
    });
  
    return data;
  };
  

  const handleNextClick = (e, targetId) => {
    e.preventDefault();
    const section = e.currentTarget.closest(".section-bg");
    const hasSelection = section.querySelectorAll(
      'input[type="text"], input[type="email"], input[type="radio"]:checked, input[type="checkbox"]:checked'
    ).length > 0;
  
    const alertElement = section.querySelector(".alert.alert-info");
  
    if (hasSelection) {
      setSuccess(false);
      const formData = gatherDataFromSections(); // Collect all data, including radio and checkboxes
      console.log(formData); // You can check the data here
      alertElement.classList.add("hide");
      document.getElementById(targetId).scrollIntoView({ behavior: "smooth" });
    } else {
      alertElement.classList.remove("hide");
      setSuccess(true);
    }
  };
  

  const handleBackClick = (e, targetId) => {
    e.preventDefault();
    document.getElementById(targetId).scrollIntoView({ behavior: "smooth" });
  };

  const [submittedData, setSubmittedData] = useState(null); // State to store the submitted data


  const onSubmit = async (formData) => {
    const url = window.location.href;
    formData.form_path = url.split("?")[0];
    setLoading(true);
  
    try {
      const response = await axios.post(
        // `https://tekrevol-form.tekstagearea.com/contact-form.php`,
        "https://api.tekrevol.com/api/create-project",
        formData
      );
  
      setSubmittedData(formData);
      console.log("Form data submitted:", formData);
      setSuccess(true);
      
      // alert("Thank you for submitting the form!");
      
      setTimeout(() => {
        setSuccess(false);

        console.log(response);
        // console.log(response?.data?.data?.id);
        window.location.href = `/estimation?projectId=${response?.data?.data?.id}`;
      }, 2000);
  
    } catch (error) {
      console.error("Error submitting form:", error);
    } finally {
      setLoading(false);
      reset({
        project_name: "",
        name: "",
        email: "",
        phone: "",
        nda: "",
        description: "",
      });
    }
  };
  

// const onSubmit = async (data) => {
//   const url = window.location.href;
//   data.form_path = url.split("?")[0];
//   setLoading(true);

//   try {
//     const response = await axios.post(
//       `https://tekrevol-form.tekstagearea.com/contact-form.php`,
//       data
//     );
    
//     // Store submitted data in the state
//     setSubmittedData(data);

//     // Log the submitted data for review
//     console.log("Form data submitted:", data);

//     setSuccess(true);
//     setTimeout(() => {
//       setSuccess(false);
//     }, 2000);

//     // Optionally, show a confirmation message or redirect the user
//     alert("Thank you for submitting the form!");

//   } catch (error) {
//     console.error("Error submitting form:", error);
//   } finally {
//     setLoading(false);
//     reset({
//       name: "",
//       email: "",
//       phone: "",
//       nda: "",
//       description: "",
//     });
//   }
// };


//   const onSubmit = async (data) => {
//     const url = window.location.href;
//     data.form_path = url.split("?")[0];
//     setLoading(true);
  
//     try {
//       // Post data to your server
//       const response = await axios.post(
//         `https://tekrevol-form.tekstagearea.com/contact-form.php`,
//         data
//       );
  
//       // Display success message or perform additional actions
//       setSuccess(true);
  
//       // Here you can process the data further if needed:
//       console.log("Form data submitted successfully:", data);
  
//       // Example: Store data in local storage
//       localStorage.setItem('submittedFormData', JSON.stringify(data));
  
//       // Example: Redirect to another page after successful submission
//       // window.location.href = "/thank-you";
  
//       // Reset the form after a short delay
//       setTimeout(() => {
//         setSuccess(false);
//         reset({
//           name: "",
//           email: "",
//           phone: "",
//           nda: "",
//           description: "",
//         });
//       }, 2000);
  
//     } catch (error) {
//       console.error("Error submitting form:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
  

  return (
    <>
    <form id="submit-form" onSubmit={handleSubmit(onSubmit)}>
      <section id="section1" className="section-height section-bg">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-10 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="row">
                <div className="col-12 stp-sec">
                  <h1>Choose the desired platform</h1>
                  <span className="alert alert-info hide">
                    Select any One option
                  </span>
                </div>
                <div className="col-6 col-sm-12 col-md-4 padding-0">
                  <div className="boxes">
                    <label className="box-label">
                      <input type="radio" name="platform" value="10" required {...register("platform")} />
                      <span className="checkmark"></span>
                      <div className="box-img">
                        <img
                          src={androidImg}
                          className="normal-img"
                          alt="android"
                        />
                        <img
                          src={androidHoverImg}
                          className="hover-img"
                          alt="android-hover"
                        />
                        <h2>Android App</h2>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-6 col-sm-12 col-md-4 padding-0">
                  <div className="boxes">
                    <label className="box-label">
                      <input type="radio" name="platform" value="20" {...register("platform")}/>
                      <span className="checkmark"></span>
                      <div className="box-img">
                        <img src={isoImg} className="normal-img" alt="iso" />
                        <img
                          src={isoHoverImg}
                          className="hover-img"
                          alt="iso-hover"
                        />
                        <h2>iOS App</h2>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-6 col-sm-12 col-md-4 padding-0">
                  <div className="boxes">
                    <label className="box-label">
                      <input type="radio" name="platform" value="30" {...register("platform")}/>
                      <span className="checkmark"></span>
                      <div className="box-img">
                        <img
                          src={crossPlatformImg}
                          className="normal-img"
                          alt="cross-plateform"
                        />
                        <img
                          src={crossPlatformHoverImg}
                          className="hover-img"
                          alt="cross-plateform-hover"
                        />
                        <h2>Both</h2>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-sec">
                <div className="back-btn">
                  {/* Add back button functionality if needed */}
                </div>
                <div className="next-btn">
                  <input
                    type="button"
                    data-id="section2"
                    className="next require"
                    id="submit-1"
                    value="NEXT"
                    onClick={(e) => handleNextClick(e, "section2")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="section2" className="section-height section-bg">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 padding-0">
                  <div className="stpleft">
                    <h2>What type of project do you need?</h2>
                    <span className="alert alert-info hide">
                      Select any One option
                    </span>
                  </div>
                </div>
                <div className="col-6 col-sm-12 col-md-3 padding-0 mb-4">
                  <div className="boxes">
                    <label className="box-label">
                      <input type="radio" name="project_type" value="1" {...register("project_type")} />
                      <span className="checkmark"></span>
                      <div className="box-img">
                        <img
                          src={ecommerceImg}
                          className="normal-img"
                          alt="e-commerce"
                        />
                        <img
                          src={ecommerceHoverImg}
                          className="hover-img"
                          alt="e-commerce-hover"
                        />
                        <h2>E-commerce</h2>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-6 col-sm-12 col-md-3 padding-0 mb-4">
                  <div className="boxes">
                    <label className="box-label">
                      <input type="radio" name="project_type" value="2" {...register("project_type")} />
                      <span className="checkmark"></span>
                      <div className="box-img">
                        <img
                          src={socialImg}
                          className="normal-img"
                          alt="social"
                        />
                        <img
                          src={socialHoverImg}
                          className="hover-img"
                          alt="social-hover"
                        />
                        <h2>Social Media</h2>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-6 col-sm-12 col-md-3 padding-0 mb-4">
                  <div className="boxes">
                    <label className="box-label">
                      <input type="radio" name="project_type" value="3" {...register("project_type")} />
                      <span className="checkmark"></span>
                      <div className="box-img">
                        <img
                          src={bookingImg}
                          className="normal-img"
                          alt="booking"
                        />
                        <img
                          src={bookingHoverImg}
                          className="hover-img"
                          alt="booking-hover"
                        />
                        <h2>Booking</h2>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-6 col-sm-12 col-md-3 padding-0 mb-4">
                  <div className="boxes">
                    <label className="box-label">
                      <input type="radio" name="project_type" value="4" {...register("project_type")} />
                      <span className="checkmark"></span>
                      <div className="box-img">
                        <img
                          src={cabAppImg}
                          className="normal-img"
                          alt="cab-app"
                        />
                        <img
                          src={cabAppHoverImg}
                          className="hover-img"
                          alt="cab-app-hover"
                        />
                        <h2>Cab App</h2>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="col-6 col-sm-12 col-md-3 padding-0 mb-4">
                  <div
                    className="boxes clickable"
                    data-url="https://www.tekrevol.com/contact#contact-content"
                  >
                    <label className="box-label">
                      <i className="fas fa-external-link-alt"></i>
                      <div className="box-img">
                        <img
                          src={customAppImg}
                          className="normal-img"
                          alt="custom-app"
                        />
                        <img
                          src={customAppHoverImg}
                          className="hover-img"
                          alt="custom-app-hover"
                        />
                        <h2>Custom App</h2>
                      </div>
                    </label>
                  </div>
                </div>
                <div className="btn-sec">
                  <div className="back-btn">
                    <a data-id="section1" className="back" onClick={(e) => handleBackClick(e, 'section1')}>
                      <i className="fas fa-long-arrow-alt-left"></i> BACK
                    </a>
                  </div>
                  <div className="next-btn">
                    <input
                      type="submit"
                      data-id="section3"
                      id="submit-2"
                      value="NEXT"
                      onClick={(e) => handleNextClick(e, "section3")}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="section3" className="section-height section-bg ques-dynamic">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="stpleft">
                <div className="point-number">
                  <span>1</span> / 10
                </div>
                <h2>How would you like your users to sign-up?</h2>
                <p></p>
                <span className="alert alert-info hide">
                  Select any One option
                </span>
              </div>
              <div className="section--main">
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="31" name="question[14][]" {...register("question[14][]")} />
                      <span className="checkmark"></span>
                      Email
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="33" name="question[14][]" {...register("question[14][]")} />
                      <span className="checkmark"></span>
                      Social Media
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="34" name="question[14][]" {...register("question[14][]")} />
                      <span className="checkmark"></span>
                      Phone Number
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-sec">
                <div className="back-btn">
                  <a data-id="section2" className="back" onClick={(e) => handleBackClick(e, 'section2')}>
                    <i className="fas fa-long-arrow-alt-left"></i> BACK
                  </a>
                </div>
                <div className="next-btn">
                  <input
                    type="button"
                    data-id="section4"
                    className="next require"
                    value="NEXT"
                    onClick={(e) => handleNextClick(e, "section4")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="section4" className="section-height section-bg ques-dynamic">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="stpleft">
                <div className="point-number">
                  <span>2</span> / 10
                </div>
                <h2>What type of user profile would you prefer?</h2>
                <p></p>
                <span className="alert alert-info hide">
                  Select any One option
                </span>
              </div>
              <div className="section--main">
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="radio" value="40" name="question[17]" {...register("question[17]")} />
                      <span className="checkmark"></span>
                      Simple Profile
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="radio" value="41" name="question[17]" {...register("question[17]")} />
                      <span className="checkmark"></span>
                      Complex Profile
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-sec">
                <div className="back-btn">
                  <a data-id="section3" className="back" onClick={(e) => handleBackClick(e, 'section3')}>
                    <i className="fas fa-long-arrow-alt-left"></i> BACK
                  </a>
                </div>
                <div className="next-btn">
                  <input
                    type="button"
                    data-id="section5"
                    className="next require"
                    value="NEXT"
                    onClick={(e) => handleNextClick(e, "section5")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="section5" className="section-height section-bg ques-dynamic">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="stpleft">
                <div className="point-number">
                  <span>3</span> / 10
                </div>
                <h2>What type of map integration would you prefer?</h2>
                <p></p>
                <span className="alert alert-info hide">
                  Select any One option
                </span>
              </div>
              <div className="section--main">
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="42" name="question[18][]" {...register("question[18][]")} />
                      <span className="checkmark"></span>
                      Simple Map
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="43" name="question[18][]" {...register("question[18][]")} />
                      <span className="checkmark"></span>
                      Geofencing
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="44" name="question[18][]" {...register("question[18][]")} />
                      <span className="checkmark"></span>
                      Search Places
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-sec">
                <div className="back-btn">
                  <a data-id="section4" className="back" onClick={(e) => handleBackClick(e, 'section4')}>
                    <i className="fas fa-long-arrow-alt-left"></i> BACK
                  </a>
                </div>
                <div className="next-btn">
                  <input
                    type="button"
                    data-id="section6"
                    className="next require"
                    value="NEXT"
                    onClick={(e) => handleNextClick(e, "section6")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="section6" className="section-height section-bg ques-dynamic">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="stpleft">
                <div className="point-number">
                  <span>4</span> / 10
                </div>
                <h2>How do you want your users to manage and upload images?</h2>
                <p></p>
                <span className="alert alert-info hide">
                  Select any One option
                </span>
              </div>
              <div className="section--main">
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="45" name="question[19][]"  {...register("question[19][]")} />
                      <span className="checkmark"></span>
                      Direct Upload
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="46" name="question[19][]"  {...register("question[19][]")} />
                      <span className="checkmark"></span>
                      Capture and Upload
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="47" name="question[19][]"  {...register("question[19][]")} />
                      <span className="checkmark"></span>
                      Image Editing
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="48" name="question[19][]"  {...register("question[19][]")} />
                      <span className="checkmark"></span>
                      Create Album
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="49" name="question[19][]"  {...register("question[19][]")} />
                      <span className="checkmark"></span>
                      Filters
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-sec">
                <div className="back-btn">
                  <a data-id="section5" className="back" onClick={(e) => handleBackClick(e, 'section5')}>
                    <i className="fas fa-long-arrow-alt-left"></i> BACK
                  </a>
                </div>
                <div className="next-btn">
                  <input
                    type="button"
                    data-id="section7"
                    className="next require"
                    value="NEXT"
                    onClick={(e) => handleNextClick(e, "section7")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="section7" className="section-height section-bg ques-dynamic">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="stpleft">
                <div className="point-number">
                  <span>5</span> / 10
                </div>
                <h2>How do you want videos to be played?</h2>
                <p></p>
                <span className="alert alert-info hide">
                  Select any One option
                </span>
              </div>
              <div className="section--main">
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="52" name="question[20][]" {...register("question[20][]")} />
                      <span className="checkmark"></span>
                      Stream Audio or Video
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="53" name="question[20][]" {...register("question[20][]")} />
                      <span className="checkmark"></span>
                      Live Broadcasting
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-sec">
                <div className="back-btn">
                  <a data-id="section6" className="back" onClick={(e) => handleBackClick(e, 'section6')}>
                    <i className="fas fa-long-arrow-alt-left"></i> BACK
                  </a>
                </div>
                <div className="next-btn">
                  <input
                    type="button"
                    data-id="section8"
                    className="next require"
                    value="NEXT"
                    onClick={(e) => handleNextClick(e, "section8")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="section8" className="section-height section-bg ques-dynamic">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="stpleft">
                <div className="point-number">
                  <span>6</span> / 10
                </div>
                <h2>
                  What type of social features would you like in your app?
                </h2>
                <p></p>
                <span className="alert alert-info hide">
                  Select any One option
                </span>
              </div>
              <div className="section--main">
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="54" name="question[21][]" {...register("question[21][]")} />
                      <span className="checkmark"></span>
                      Comments, Like, Share
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="56" name="question[21][]" {...register("question[21][]")} />
                      <span className="checkmark"></span>
                      Post (text, image and video)
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="57" name="question[21][]" {...register("question[21][]")} />
                      <span className="checkmark"></span>
                      User Tagging
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="58" name="question[21][]" {...register("question[21][]")} />
                      <span className="checkmark"></span>
                      Check-ins
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="59" name="question[21][]" {...register("question[21][]")} />
                      <span className="checkmark"></span>
                      Hash-tags
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="60" name="question[21][]" {...register("question[21][]")} />
                      <span className="checkmark"></span>
                      Bookmarks
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-sec">
                <div className="back-btn">
                  <a data-id="section7" className="back" onClick={(e) => handleBackClick(e, 'section7')}>
                    <i className="fas fa-long-arrow-alt-left"></i> BACK
                  </a>
                </div>
                <div className="next-btn">
                  <input
                    type="button"
                    data-id="section9"
                    className="next require"
                    value="NEXT"
                    onClick={(e) => handleNextClick(e, "section9")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="section9" className="section-height section-bg ques-dynamic">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="stpleft">
                <div className="point-number">
                  <span>7</span> / 10
                </div>
                <h2>
                  How do you want your users to communicate within the app?
                </h2>
                <p></p>
                <span className="alert alert-info hide">
                  Select any One option
                </span>
              </div>
              <div className="section--main">
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="61" name="question[22][]" {...register("question[22][]")} />
                      <span className="checkmark"></span>
                      Simple Inbox
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="62" name="question[22][]" {...register("question[22][]")} />
                      <span className="checkmark"></span>
                      Live Chat
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="63" name="question[22][]" {...register("question[22][]")} />
                      <span className="checkmark"></span>
                      Media Sharing
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="64" name="question[22][]" {...register("question[22][]")} />
                      <span className="checkmark"></span>
                      Group Chat
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="65" name="question[22][]" {...register("question[22][]")} />
                      <span className="checkmark"></span>
                      Voice and Video Call
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-sec">
                <div className="back-btn">
                  <a data-id="section8" className="back" onClick={(e) => handleBackClick(e, 'section8')}>
                    <i className="fas fa-long-arrow-alt-left"></i> BACK
                  </a>
                </div>
                <div className="next-btn">
                  <input
                    type="button"
                    data-id="section10"
                    className="next require"
                    value="NEXT"
                    onClick={(e) => handleNextClick(e, "section10")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id="section10"
        className="section-height section-bg ques-dynamic"
      >
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="stpleft">
                <div className="point-number">
                  <span>8</span> / 10
                </div>
                <h2>Do you want a payment gateway integration?</h2>
                <p></p>
                <span className="alert alert-info hide">
                  Select any One option
                </span>
              </div>
              <div className="section--main">
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="radio" value="66" name="question[23]"  {...register("question[23][]")} />
                      <span className="checkmark"></span>
                      Subscription
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="radio" value="67" name="question[23]"  {...register("question[23][]")} />
                      <span className="checkmark"></span>
                      No Subscription
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-sec">
                <div className="back-btn">
                  <a data-id="section9" className="back" onClick={(e) => handleBackClick(e, 'section9')}>
                    <i className="fas fa-long-arrow-alt-left"></i> BACK
                  </a>
                </div>
                <div className="next-btn">
                  <input
                    type="button"
                    data-id="section11"
                    className="next require"
                    value="NEXT"
                    onClick={(e) => handleNextClick(e, "section11")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id="section11"
        className="section-height section-bg ques-dynamic"
      >
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="stpleft">
                <div className="point-number">
                  <span>9</span> / 10
                </div>
                <h2>Do you need Admin panel to manage your App?</h2>
                <p></p>
                <span className="alert alert-info hide">
                  Select any One option
                </span>
              </div>
              <div className="section--main">
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="radio" value="116" name="question[39]"  {...register("question[39]")}/>
                      <span className="checkmark"></span>
                      Yes
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="radio" value="117" name="question[39]"  {...register("question[39]")}/>
                      <span className="checkmark"></span>
                      No
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-sec">
                <div className="back-btn">
                  <a data-id="section10" className="back" onClick={(e) => handleBackClick(e, 'section10')}>
                    <i className="fas fa-long-arrow-alt-left"></i> BACK
                  </a>
                </div>
                <div className="next-btn">
                  <input
                    type="button"
                    data-id="section12"
                    className="next require"
                    value="NEXT"
                    onClick={(e) => handleNextClick(e, "section12")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section
        id="section12"
        className="section-height section-bg ques-dynamic"
      >
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-10 m-md-auto mt-100">
              <div className="stpleft">
                <div className="point-number">
                  <span>10</span> / 10
                </div>
                <h2>What other features would you like to have in your app?</h2>
                <p>Add optional features in your app to stand out.</p>
                <span className="alert alert-info hide">
                  Select any One option
                </span>
              </div>
              <div className="section--main">
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="68" name="question[24][]" {...register("question[24][]")} />
                      <span className="checkmark"></span>
                      Review or Rating
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="69" name="question[24][]" {...register("question[24][]")} />
                      <span className="checkmark"></span>
                      Search Bar
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="70" name="question[24][]" {...register("question[24][]")} />
                      <span className="checkmark"></span>
                      Coupons
                    </label>
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-6 m-b-20 padding-0">
                  <div className="boxes small-box">
                    <label className="box-label">
                      <input type="checkbox" value="74" name="question[24][]" {...register("question[24][]")} />
                      <span className="checkmark"></span>
                      Push Notification
                    </label>
                  </div>
                </div>
              </div>
              <div className="btn-sec">
                <div className="back-btn">
                  <a data-id="section11" className="back" onClick={(e) => handleBackClick(e, 'section11')}>
                    <i className="fas fa-long-arrow-alt-left"></i> BACK
                  </a>
                </div>
                <div className="next-btn">
                  <input
                    type="submit"
                    value="Finish"
                    data-id="email-form"
                    onClick={(e) => handleNextClick(e, "email-form")}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section id="email-form" className="">
          <div className="container h-100">
            <div className="row h-100">
              <div className="col-12 col-sm-12 col-md-8 col-lg-6 m-auto">
                <img src={FormImage} className="img-fluid" alt="Email Form" />
              </div>
              <div className="col-12 col-sm-12 col-md-8 col-lg-6 m-auto">
                <div className="form-content">
                  <h2>You are almost there...</h2>
                  <p>
                    Please fill out this short form and you will immediately get
                    a detailed estimate.
                  </p>
                </div>
                <div className="form-div">
                  <label htmlFor="project_name">PROJECT NAME</label>
                  <input
                    type="text"
                    id="project_name"
                    placeholder="YOUR PROJECT NAME"
                    {...register("project_name", { required: true })}
                  />
                  {errors.project_name && <span>This field is required</span>}
                </div>
                <div className="form-div">
                  <label htmlFor="name">YOUR NAME</label>
                  <input
                    type="text"
                    id="name"
                    placeholder="YOUR NAME"
                    {...register("name", { required: true })}
                  />
                  {errors.name && <span>This field is required</span>}
                </div>
                <div className="form-div">
                  <label htmlFor="email">YOUR EMAIL</label>
                  <input
                    type="email"
                    id="email"
                    placeholder="YOUR EMAIL"
                    {...register("email", { required: true })}
                  />
                  {errors.email && <span>This field is required</span>}
                </div>
                <div className="form-div">
                  <label htmlFor="phone">YOUR PHONE NUMBER</label>
                  <input
                    type="text"
                    id="phone"
                    placeholder="YOUR PHONE NUMBER"
                    {...register("phone", { required: true })}
                    maxLength="16"
                    onKeyPress={(e) => e.charCode >= 48 && e.charCode <= 57}
                  />
                  {errors.phone && <span>This field is required</span>}
                </div>
                <div className="form-submit">
                  <input
                    type="hidden"
                    name="client_ip"
                    className="client_ip"
                    value="110.38.68.19"
                  />
                  <input
                    type="submit"
                    value="Get the Estimate"
                    id="submit-form"
                    onSubmit={handleSubmit(onSubmit)}
                  />
                </div>
                {loading && <div>Loading...</div>}
                {success && <div>Form submitted successfully!</div>}
              </div>
            </div>
          </div>

        {/* Display submitted data after form submission */}
        {submittedData && (
          <div className="submitted-data">
            <h2>Submitted Data</h2>
            <pre>{JSON.stringify(submittedData, null, 2)}</pre>
        </div>
        )}
      </section>
        </form>
    </>
  );
}

export default MultiStep;
